import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

/**
 * All config. options available here:
 * https://cookieconsent.orestbida.com/reference/configuration-reference.html
 */

declare global {
  interface Window {
    dataLayer: any[]
    Shopify: any
  }
  interface Navigator {
    globalPrivacyControl?: boolean
  }
}

export const CAT_NECESSARY = 'necessary'
export const CAT_FUNCTIONALITY = 'functionality'
export const CAT_ANALYTICS = 'analytics'
export const CAT_MARKETING = 'marketing'
export const CAT_SECURITY = 'security'

type loadFeatureError = { error: [string] }

function updateShopifyConsent() {
  window.Shopify.loadFeatures(
    [
      {
        name: 'consent-tracking-api',
        version: '0.1',
      },
    ],
    (error: loadFeatureError) => {
      if (error) {
        // Rescue error
      }
      // If error is false, the API has loaded and ready to use!
      window.Shopify.customerPrivacy.setTrackingConsent(
        {
          analytics: CookieConsent.acceptedCategory(CAT_ANALYTICS),
          marketing: CookieConsent.acceptedCategory(CAT_MARKETING),
          preferences: CookieConsent.acceptedCategory(CAT_FUNCTIONALITY),
        },
        () => console.log('Consent captured'),
      )
    },
  )
}

const gpcFlagIsTrue = navigator.globalPrivacyControl || false

export default CookieConsent.run({
  revision: 0,
  autoShow: !gpcFlagIsTrue,
  guiOptions: {
    consentModal: {
      layout: 'bar inline',
      position: 'bottom',
      equalWeightButtons: false,
      flipButtons: false,
    },
    preferencesModal: {
      layout: 'box',
      position: 'right',
      equalWeightButtons: false,
      flipButtons: false,
    },
  },
  onFirstConsent: () => {
    updateShopifyConsent()
  },
  onConsent: () => {
    updateShopifyConsent()
  },
  onChange: () => {
    updateShopifyConsent()
  },
  categories: {
    [CAT_NECESSARY]: {
      readOnly: true,
    },
    [CAT_FUNCTIONALITY]: {
      enabled: !gpcFlagIsTrue,
    },
    [CAT_ANALYTICS]: {
      enabled: !gpcFlagIsTrue,
    },
    [CAT_MARKETING]: {
      enabled: !gpcFlagIsTrue,
    },
  },
  mode: 'opt-out',
  language: {
    default: 'en',
    translations: {
      en: {
        consentModal: {
          title: 'Do not Sell or Share My Personal Information',
          description:
            'We use cookies and similar technologies to help our site work, understand how it’s used, and show you more relevant content and ads. Learn more in our <a href="/policies/privacy-policy">Privacy Policy</a>.',
          acceptAllBtn: 'Accept all',
          showPreferencesBtn: 'Preferences',
        },
        preferencesModal: {
          title: 'Consent Preferences Center',
          acceptAllBtn: 'Accept all',
          acceptNecessaryBtn: 'Reject all',
          savePreferencesBtn: 'Save preferences',
          closeIconLabel: 'Close modal',
          serviceCounterLabel: 'Service|Services',
          sections: [
            {
              title: 'Cookie Usage',
              description:
                'Cookies and similar technologies help our site function and improve your experience. We use them to enable core site features, understand how the website is used, and improve our services. We may also use them (including via trusted third parties) to show you more relevant advertising on other websites and apps. You can manage your preferences here at any time, except for cookies that are strictly necessary to operate the website.',
            },
            {
              title: 'Strictly Necessary Cookies <span class="pm__badge">Always Enabled</span>',
              description:
                'These cookies are required for the site to function and can’t be turned off in our systems. They’re usually set in response to actions you take- such as setting your privacy preferences, signing in, or filling out forms. You can set your browser to block or alert you about these cookies, but some parts of the site may not work properly.',
              linkedCategory: 'necessary',
            },
            {
              title: 'Functionality Cookies',
              description:
                'These cookies help enhance site features and personalization. They may be set by us or by third parties whose services we use on our site. If you disable these cookies, some features and services may not work properly. Use the toggle above to enable or disable them.',
              linkedCategory: 'functionality',
            },
            {
              title: 'Analytics Cookies',
              description:
                'These cookies help us understand how visitors use our site- such as where traffic comes from, which pages are viewed most, and how people move through the site- so we can measure performance and improve. If you disable these cookies, we won’t be able to collect analytics data to help us optimize the site. Use the toggle above to enable or disable them.',
              linkedCategory: 'analytics',
            },
            {
              title: 'Marketing Cookies',
              description:
                'These cookies may be set by our advertising partners and used across our site. They may be used to build a profile of your interests and show you more relevant ads on other websites and apps. If you disable these cookies, you may still see ads, but they may be less relevant. Use the toggle above to enable or disable them.',
              linkedCategory: 'marketing',
            },
          ],
        },
      },
    },
  },
})

const preferenceModalElements = document.querySelectorAll('.show-preferencesModal')
preferenceModalElements.forEach((element) => {
  element.addEventListener('click', () => {
    CookieConsent.showPreferences()
  })
})
